const COHORT_KEY = 'user_cohort';

class UserStore {
	cohort: string | null;
	constructor() {
		this.cohort = this.getCohort();
	}

	getCohort() {
		const cohort = localStorage.getItem(COHORT_KEY);
		if (cohort) {
			this.cohort = cohort;
			return cohort;
		}
		return null;
	}

	setCohort(cohort: string) {
		localStorage.setItem(COHORT_KEY, cohort);
	}
}

export const userStore = new UserStore();